









import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';

@Component({
  name: 'GClassManagementClassTrend',
  components: {},
  computed: {},
  methods: {},
})
export default class GClassManagementClassTrend extends mixins(GPageBase) {
  mounted() {}

  get schoolClassTrendResult() {
    return schoolClassModule.schoolClassTrendResult;
  }
}
